module.exports = __webpack_public_path__ + "static/media/gallery-13.5e5fbdbc.jpeg";